// extracted by mini-css-extract-plugin
export default {"container":"paper_container__3TVpw","header":"paper_header__PXPIy","footer":"paper_footer__ODRdK","content":"paper_content__WJHg1"};